"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeGOVT = function CategoryCodeGOVT(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeGOVT"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M13.061,11.905H2.939a.386.386,0,0,0-.275.109.341.341,0,0,0-.117.258V12.8a.207.207,0,0,0,.207.207H13.246a.207.207,0,0,0,.207-.207v-.528a.341.341,0,0,0-.117-.258A.386.386,0,0,0,13.061,11.905Z"
  }), _react.default.createElement("path", {
    d: "M12.888,5.154,8.071,3.008a.176.176,0,0,0-.142,0L3.112,5.154a.21.21,0,0,0-.119.194v.393a.2.2,0,0,0,.19.209h9.634a.2.2,0,0,0,.19-.209V5.348A.21.21,0,0,0,12.888,5.154Z"
  }), _react.default.createElement("path", {
    d: "M3.274,11.17v.161a.207.207,0,0,0,.207.206h9.038a.207.207,0,0,0,.207-.206V11.17a.343.343,0,0,0-.117-.259.39.39,0,0,0-.275-.109H12V6.6a.207.207,0,0,0-.207-.207H10.751a.207.207,0,0,0-.206.207v4.2H9.818V6.6a.207.207,0,0,0-.207-.207H8.57a.207.207,0,0,0-.206.207v4.2H7.636V6.6a.207.207,0,0,0-.206-.207H6.389a.207.207,0,0,0-.207.207v4.2H5.455V6.6a.207.207,0,0,0-.206-.207H4.208A.207.207,0,0,0,4,6.6v4.2H3.666a.39.39,0,0,0-.275.109A.343.343,0,0,0,3.274,11.17Z"
  }))));
};

var _default = CategoryCodeGOVT;
exports.default = _default;